import React from "react";
import { altColor } from "../../utils/constants";

export default function ArrowDownBlueIcon({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.58 4.43">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <g id="up-arrow">
            <g id="Gruppe_39" data-name="Gruppe 39">
              <g id="Gruppe_38" data-name="Gruppe 38">
                <path
                  id="Pfad_206"
                  data-name="Pfad 206"
                  d="M.18,1.07,3.35,4.24a.62.62,0,0,0,.89,0L7.42,1.07A.63.63,0,0,0,7.36.18a.62.62,0,0,0-.84,0L3.8,2.9,1.07.18a.62.62,0,0,0-.89,0,.63.63,0,0,0,0,.88Z"
                  fill={color}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
